<div class="flex flex-col !h-[calc(100dvh-var(--layout-header-height)-var(--chat-gap))]">
  <div class="flex justify-between my-2">
    <div>
      <p-button
        size="small"
        [styleClass]="'text-xs'"
        label="{{ 'New message' | translate }}"
        [rounded]="true"
        (click)="write()" />
    </div>

    <div>
      <div class="flex items-center gap-2">
        <div
          class="cursor-pointer opacity-50 hover:opacity-100 hover:text-primary text-xs mr-1 md:mr-2"
          (click)="searchbar()">
          <mat-icon style="height: initial; width: initial"
            >{{ show_search_bar ? 'search_off' : 'search' }}
          </mat-icon>
        </div>
        @if (selected_view_type === 'widget') {
          <div
            class="cursor-pointer opacity-50 hover:opacity-100 hover:text-primary text-xs mr-1 md:mr-2"
            (click)="openSubPage('/communication')">
            <mat-icon style="height: initial; width: initial">settings_overscan</mat-icon>
          </div>
        }

        <div>
          <button
            class="p-panel-header-icon p-link opacity-50 hover:opacity-100 hover:text-primary text-xs"
            (click)="menu.toggle($event)">
            <span class="pi pi-ellipsis-v"></span>
          </button>
          <p-menu #menu [appendTo]="'body'" [popup]="true" [model]="items">
            <ng-template #submenuheader let-item>
              <span class="font-bold">{{ item.label }}</span>
            </ng-template>
            <ng-template #item let-item>
              @if (item?.visible !== false) {
                <a class="flex items-center p-2 cursor-pointer mb-1 gap-2">
                  <span
                    class="inline-flex items-center justify-content-center text-4xl {{
                      item?.icon_color ? item?.icon_color : 'text-primary'
                    }}">
                    <mat-icon
                      class="{{ item?.icon_color ? item?.icon_color : 'text-primary' }} "
                      fontIcon="{{ item.icon ? item.icon : 'add_circle' }}" />
                  </span>
                  <span class="inline- flex flex-col gap-1">
                    <span class="font-light text-sm">{{ item.label }}</span>
                  </span>
                </a>
              }
            </ng-template>
          </p-menu>
        </div>
      </div>
    </div>
  </div>

  @if (show_search_bar) {
    <div class="py-2 relative flex items-center">
      <input
        #messageInput
        type="text"
        pInputText
        class="w-full py-2 px-5"
        autoFocus
        placeholder="{{ 'Search...' | translate }}" />
    </div>
  }

  <div
    class="flex-grow overflow-y-auto touch-pan-y"
    offcononInfiniteScroll
    [totalItems]="rooms().pagination?.total || 0"
    [currentPage]="$any(rooms().pagination)?.currentPage || 1"
    [pageSize]="pageSize"
    [lazyLoading]="lazyLoading"
    [scrollThreshold]="150"
    (loadMore)="loadMoreData()">
    @if (rooms()) {
      <div>
        @for (room of rooms().rooms; track room.id) {
          <offconon-chat-room-display
            class="block my-2"
            [platform]="platform"
            [logged_user]="logged_user"
            [parameters]="parameters"
            [room]="room"
            [selectedBusiness]="selectedBusiness"
            (selectedChatRoomId)="selectedChatRoomId.emit($event)" />
        }

        @if (rooms().pagination?.totalPages! > currentPage) {
          <div class="flex justify-center mt-3">
            <p-button severity="secondary" size="small" (click)="loadMoreData()">{{
              'Load more' | translate
            }}</p-button>
          </div>
        }
      </div>
    }
  </div>

  <offconon-ads-message-render />
</div>
